// 计费单

import { HttpGetInventoryWarehouse,HttpGetInventoryWarehouseExport } from '@/service/inventory';
import TableList from "@components/templates/tablelist";
import { mapGetters } from 'vuex';
export default {
    mixins: [TableList],
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            Tabs: { show: true },
            formData: {},
            
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            Plugins: { show: true },
        };
    },
    watch:{
        "$route":function (to,from) {
            this.$set(this.formData,"search[EQ_organizationId]",this.isAdmin() ? '' : global.SYSID)
        }
    },
    methods: {
        ajaxRequest: HttpGetInventoryWarehouse,
        interceptRequest(params) {
            params.state = this.isAdmin() ? '1' : '0';
            this.formData.state = params.state;
            if (params.search.IN_warehouseId) {
                params.warehouseIds = params.search.IN_warehouseId;
                this.formData.warehouseIds = params.search.IN_warehouseId;
                delete params.search.IN_warehouseId;
                delete this.formData.search.IN_warehouseId;
                // console.log(params)
                return params
            } else {
                return params
            }
        },
        handleOperates(params = "", type, batch) {
            switch (type) {
                case 'export':
                    this.handleWebfs(HttpGetInventoryWarehouseExport, this.formData, 'download')
                    break;
            }
        },
        isAdmin() {
            return this.$route.name === 'inventorySerWarehouse';
        },
    },
    computed: {
        ...mapGetters('dictionary', ['getProductList','getSysAllList', 'getBillcusorgList', 'getCusproductList', 'getSystemWareList','getAdminTransferWarehouse', 'getTransferWarehouse']),
        ...mapGetters('common', ['getInventoryType', 'getProductType']),
        ToolsData() {
            return [
                {
                    name: this.$t('boss.purchase.export',{defaultValue:'导出'}),
                    operate: "export",
                    theme: "info",
                },
            ]
        },
        SearchsData() {
            return [
                {
                    label: this.$t('tms.ship.organizationt',{defaultValue:'组织'}),
                    key: 'EQ_organizationId',
                    more: true,
                    tag: 'vSelect',
                    options: this.getBillcusorgList,
                    hidden: !this.isAdmin(),
                    props: {
                        filterable: true,
                    },
                },
                {
                    label: this.$t('tms.ship.warehouse',{defaultValue:'仓库'}),
                    key: this.isAdmin() ? 'IN_orgWarehouseCode' : 'IN_orgWarehouseId',
                    show: true,
                    tag: 'vSelect',
                    options: this.isAdmin() ? this.getAdminTransferWarehouse : this.getTransferWarehouse,
                    props: {
                        filterable: true,
                        multiple: true,
                    },
                    style: "width:250px",
                },
                {
                    label: this.$t('boss.purchase.project',{defaultValue:'项目'}),
                    key: 'IN_lineId',
                    more: true,
                    tag: 'vSelect',
                    options: this.isAdmin() ? this.getCusproductList : this.getProductList,
                    props: {
                        filterable: true,
                        multiple: true,
                    },
                    style: "width:250px",
                },
                {
                    label: "SKU",
                    key: 'RCN_sku',
                    show: true,
                    tag: 'vInput',
                },
                {
                    label: this.$t('fbb.inventory.inventory_type',{defaultValue:'库存类型'}),
                    key: 'EQ_inventoryType',
                    more: true,
                    tag: 'vSelect',
                    options: this.getInventoryType,
                    props: {
                        filterable: true,
                    },
                },
                {
                    label: this.$t('boss.purchase.update_time',{defaultValue:'更新时间'}),
                    tag: 'vDatepicker',
                    key: 'BT_updatedAt',
                    show: true,
                    props: {
                        options: this.options,
                        format: 'yyyy-mm-dd ~ yyyy-mm-dd',
                        confirm: false,
                    },
                    style: "width:250px",
                },

            ]
        },
        columns() {
            return [
                {
                    title: this.$t('fbb.bill.customer',{defaultValue:'客户'}),
                    key: 'organizationId',
                    width: this.isAdmin() ? 100 : 0,
                    render: (h, {
                        row
                    }) => this.findRenderLabel(this.getSysAllList, row.organizationId)
                },
                {
                    title: this.$t('tms.ship.warehouse',{defaultValue:'仓库'}),
                    maxWidth: 200,
                    render: (h, { row }) => {
                        let orgWarehouseCode = row.orgWarehouseCode
                        const { label } = (this.isAdmin() ? this.getAdminTransferWarehouse : this.getTransferWarehouse).find(function (item) {
                            return item.attach.code == orgWarehouseCode
                        }) || {};
                        return <div>{label}</div>
                    }
                },
                {
                    title: this.$t('boss.purchase.project',{defaultValue:'项目'}),
                    render: (h, { row }) =>
                    this.findRenderLabel(
                        this.isAdmin() ? this.getCusproductList : this.getProductList,
                        row.lineId
                    )
                },
                {
                    title: 'SKU',
                    key: 'sku',
                },
                {
                    title: this.$t('fbb.inventory.product_type',{defaultValue:'产品类型'}),
                    maxWidth: 80,
                    render: (h, { row }) => {
                        let productType = row.productType
                        const { label } = this.getProductType.find(function (item) {
                            return item.value == productType
                        }) || {};
                        return <div>{label}</div>
                    }
                },
                {
                    title: this.$t('fbb.inventory.inventory_type',{defaultValue:'库存类型'}),
                    maxWidth: 80,
                    render: (h, { row }) => {
                        let inventoryType = row.inventoryType
                        const { label } = this.getInventoryType.find(function (item) {
                            return item.value == inventoryType
                        }) || {};
                        return <div>{label}</div>
                    }
                },
                {
                    title: this.$t('fbb.inventory.available_reserved_current',{defaultValue:'可用库存/预留数量/当前库存'}),
                    render:(h, { row }) => {
                        return <div><div>{row.inventoryAvailable}</div><div>{row.inventoryReserved}</div><div>{row.inventoryCurrent}</div></div>
                    }
                },
                {
                    title:  this.$t('fbb.inventory.available_reserved_quantity',{defaultValue:'仓库可用库存/仓库预留数量/仓库当前库存'}),
                    render:(h, { row }) => {
                        return <div><div>{row.warehouseInventoryAvailable}</div><div>{row.warehouseInventoryReserved}</div><div>{row.warehouseInventoryCurrent}</div></div>
                    }
                },
                {
                    title: this.$t('fbb.inventory.inventory_discrepancy_quantity',{defaultValue:'库存差异数量'}),
                    key: 'inventoryDiff',
                },
                {
                    title: this.$t('fbb.inventory.length_width_height',{defaultValue:'长*宽*高(cm)'}),
                    key: 'weight',
                    render: (h, { row }) => {
                          return <div>{row.length}*{row.width}*{row.height}</div>
                    }
                },
                {
                    title: this.$t('fbb.inventory.weight_g',{defaultValue:'重量(g)'}),
                    key: 'weight',
                    render: (h, { row }) => {
                        return <div>{row.weight}</div>
                    }
                },
                {
                    title: this.$t('boss.purchase.update_time',{defaultValue:'更新时间'}),
                    width: 150,
                    render: (h, { row }) => {
                        return <div>{row.updatedAt || '--'}</div>
                    }
                },
            ];
        },
    },
};




